import { InfoFilled } from '@element-plus/icons-vue'
import { ElButton, ElDialog, ElIcon } from 'element-plus'
import { computed, defineComponent, h, ref } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isDialogVisible = ref(false)
    const modalTitle = computed(() => props.context.attrs?.modalTitle || '')
    const modalText = computed(() => props.context.attrs?.modalText || '')
    const displayText = computed(() => props.context.attrs?.displayText || '')
    const isHtml = computed(() => /<\/?[a-z][\s\S]*>/i.test(displayText.value))
    const defaultWrapperClasses = 'cursor-pointer text-sm'
    const wrapperClasses = computed(() => {
      return [defaultWrapperClasses, props.context.attrs?.wrapperClasses || ''].join(' ').trim()
    })

    const textClasses = computed(() => props.context.attrs?.textClasses || '')

    const showDialog = () => {
      isDialogVisible.value = true
    }

    return () =>
      h('div', { class: wrapperClasses.value }, [
        isHtml.value
          ? h('span', {
              class: textClasses.value,
              innerHTML: displayText.value,
              onClick: showDialog,
            })
          : h('span', { class: textClasses.value, onClick: showDialog }, displayText.value),
        h(
          ElIcon,
          {
            class: 'cursor-pointer',
            size: '16',
            onClick: (event) => {
              event.stopPropagation()
              showDialog()
            },
          },
          () => h(InfoFilled),
        ),
        h(
          ElDialog,
          {
            modelValue: isDialogVisible.value,
            'onUpdate:modelValue': (val) => (isDialogVisible.value = val),
            title: modalTitle.value,
            width: '75%',
            appendToBody: true,
            zIndex: 4000,
          },
          {
            default: () =>
              h('div', {
                innerHTML: modalText.value,
                style: {
                  maxHeight: '400px',
                  overflowY: 'auto',
                  padding: '16px',
                },
              }),
            footer: () =>
              h(
                'div',
                { class: 'text-right' },
                h(ElButton, { type: 'primary', onClick: () => (isDialogVisible.value = false) }, () => 'Close'),
              ),
          },
        ),
      ])
  },
})
